export default {"src":"/_next/static/media/signedWill.abcbe47d.svg","height":152,"width":240,"blurWidth":0,"blurHeight":0};